import getWindow from "./window";

// Carried on the url fragment alongside ctaref and featureref1, following the
// same "key-value" convention, so that a recommendation click reaches the
// destination PDP however the customer opens it - including in a new tab,
// where sessionStorage is not inherited.
const FRAGMENT_KEY = "recsreqid";

let sourceRecsRequestId;
let hasReadFragment = false;

export function recsRequestIdFragment(recsRequestId) {
  return recsRequestId
    ? `&${FRAGMENT_KEY}-${encodeURIComponent(recsRequestId)}`
    : "";
}

// Pairs are split on "#" as well as "&": some carousels append their own
// ctaref block to a url that already carries one, leaving two "#" in the
// fragment. Only the first hyphen delimits the key, because values contain
// hyphens of their own - uuids, and ctaref values such as
// "styled+for+you+-+similar+items".
function readFragment() {
  const hash = getWindow().location?.hash;

  if (!hash) {
    return undefined;
  }

  const pair = hash
    .replace(/^#/, "")
    .split(/[&#]/)
    .find((part) => part.startsWith(`${FRAGMENT_KEY}-`));

  if (!pair) {
    return undefined;
  }

  try {
    return decodeURIComponent(pair.slice(FRAGMENT_KEY.length + 1)) || undefined;
  } catch {
    return undefined;
  }
}

// Read once and held: add_to_cart and add_to_wishlist fire long after
// view_item, and the value must not depend on the url being untouched in
// between.
export function getSourceRecsRequestId() {
  if (!hasReadFragment) {
    hasReadFragment = true;
    sourceRecsRequestId = readFragment();
  }

  return sourceRecsRequestId;
}
